import React, { useState, useEffect } from 'react';
import { ChevronRight, Dumbbell, ClipboardList } from 'lucide-react';
import './Modalidades.css';
import API_BASE_URL from '../../../config/api';

const Modalidades = () => {
  const [modalidades, setModalidades] = useState([]);
  const [escalaos, setEscalaos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [sportsRes, escalaosRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/sports`),
        fetch(`${API_BASE_URL}/api/escalaos`)
      ]);

      if (sportsRes.ok) {
        const sportsData = await sportsRes.json();
        setModalidades(sportsData);
      }

      if (escalaosRes.ok) {
        const escalaosData = await escalaosRes.json();
        setEscalaos(escalaosData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&h=600&fit=crop';
    if (imageUrl.startsWith('http')) return imageUrl;
    return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
  };

  // Informações estáticas para cada modalidade (escalões)
  const modalidadesInfo = {
    'Atletismo': 'Benjamins a Veteranos',
    'Badminton': 'Formação e Competição',
    'Basquetebol': 'Baby-Basket a Sénior',
    'Futevólei': 'Sub-18 a Masters',
    'Futsal': 'Sub-7 a Sénior',
    'Hóquei em Patins': 'Sub-9 a Sénior',
    'Ténis de Mesa': 'Formação e Competição',
    'Voleibol': 'Mini a Sénior'
  };

  if (loading) {
    return (
      <section id="equipas" className="modalidades section-padding">
        <div className="container">
          <div className="modalidades-header">
            <h2>As Nossas Modalidades</h2>
            <p>A carregar modalidades...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="equipas" className="modalidades section-padding">
      <div className="container">
        <div className="modalidades-header animate-in">
          <span className="modalidades-subtitle">Excelência Desportiva</span>
          <h2 className="modalidades-title">As Nossas Modalidades</h2>
          <div className="modalidades-header-line"></div>
          <p className="modalidades-description">
            Modalidades diversificadas com programas de formação e competição para todas as idades,
            unindo a paixão pelo desporto à exigência da alta competição.
          </p>
        </div>

        <div className="modalidades-grid">
          {modalidades.map((modalidade, index) => (
            <div
              key={modalidade.id}
              className="modalidade-card glass-card animate-in"
              style={{ '--delay': `${0.1 * (index + 1)}s` }}
            >
              <div className="modalidade-img-wrapper">
                <img
                  src={getImageUrl(modalidade.imageUrl)}
                  alt={modalidade.name}
                  className="modalidade-img"
                />
              </div>
              <div className="modalidade-body">
                <div className="modalidade-title-row">
                  <h3>{modalidade.name}</h3>
                </div>
                <p>{modalidade.description}</p>
                <div className="modalidade-footer">
                  <span className="escaloes-label">Escalões:</span>
                  <span className="escaloes-value">
                    {(() => {
                      const sportEscalaos = escalaos.filter(e => e.sportIds && e.sportIds.includes(modalidade.id));
                      if (sportEscalaos.length > 1) {
                        const sorted = [...sportEscalaos].sort((a, b) => (a.minAge || 0) - (b.minAge || 0));
                        const cleanName = (name) => name.replace(/\s+[A-Z]$/i, '').trim();
                        return `${cleanName(sorted[0].name)} a ${cleanName(sorted[sorted.length - 1].name)}`;
                      } else if (sportEscalaos.length === 1) {
                        return sportEscalaos[0].name;
                      }
                      return (modalidadesInfo[modalidade.name] || 'Vários escalões');
                    })()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Modalidades;